<!-- 巡检路线管理 -->
<template>
  <div class="inspection-route-manage">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <!-- 自定义按钮组 -->
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">
          新建路线
        </el-button>
        <el-button
          type="success"
          icon="el-icon-check"
          size="small"
          :disabled="!ids"
          @click="handleBatchEnable"
        >
          批量启用
        </el-button>
        <el-button
          type="warning"
          icon="el-icon-close"
          size="small"
          :disabled="!ids"
          @click="handleBatchDisable"
        >
          批量禁用
        </el-button>

      </template>

      <!-- 自定义路线编号列 -->
      <template slot="routeCode" slot-scope="{ row }">
        <el-button type="text" @click.stop="handleView(row)">
          {{ row.routeCode }}
        </el-button>
      </template>

      <!-- 自定义状态列 -->
      <template slot="status" slot-scope="{ row }">
        <el-tag
          :type="row.status === 1 ? 'success' : 'info'"
          size="small"
          effect="light"
        >
          {{ row.status === 1 ? "启用" : "禁用" }}
        </el-tag>
      </template>

      <!-- 自定义操作列：整块包在 @click.stop，避免 rich_element 表格行 click 冒泡触发 avue 行编辑 -->
      <template slot="menu" slot-scope="{ row }">
        <span class="inspection-route-menu-actions" @click="absorbMenuCellClick">
          <el-button type="text" size="small" icon="el-icon-delete" @click="rowDel(row)">
            删除
          </el-button>
          <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)">
            查看
          </el-button>
          <el-button type="text" size="small" icon="el-icon-edit" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button
            type="text"
            size="small"
            :icon="row.status === 1 ? 'el-icon-video-pause' : 'el-icon-check'"
            @click="handleToggleStatus(row)"
            :style="{ color: row.status === 1 ? '#f56c6c' : '#67c23a' }"
          >
            {{ row.status === 1 ? "禁用" : "启用" }}
          </el-button>
        </span>
<!--        <el-button-->
<!--          type="text"-->
<!--          size="small"-->
<!--          icon="el-icon-document-copy"-->
<!--          @click="handleCopy(row)"-->
<!--        >-->
<!--          复制-->
<!--        </el-button>-->

      </template>
    </avue-crud>

    <!-- 新增/编辑弹窗 -->
    <route-dialog
      ref="routeDialog"
      :visible.sync="dialogVisible"
      :is-edit="isEdit"
      :form-data="formData"
      @refresh="onLoad(page)"
    />

    <!-- 复制弹窗 -->
    <route-dialog
      ref="copyDialog"
      :visible.sync="copyDialogVisible"
      :is-edit="false"
      :form-data="copyFormData"
      :is-copy="true"
      @refresh="onLoad(page)"
    />

    <!-- 查看详情弹窗 -->
    <route-view-dialog
      ref="viewDialog"
      :visible.sync="viewDialogVisible"
      :route-id="viewRouteId"
    />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { searchTimeConfig } from "@/basic-common/util/common";
import { getList, remove, updateStatusBatch } from "./api";
import RouteDialog from "./components/RouteDialog.vue";
import RouteViewDialog from "./components/RouteViewDialog.vue";

export default {
  name: "inspection-route-manage",
  mixins: [crudMixins],
  components: {
    RouteDialog,
    RouteViewDialog,
  },
  data() {
    return {
      apiConfig: { getList,remove },
      dialogVisible: false,
      copyDialogVisible: false,
      viewDialogVisible: false,
      isEdit: false,
      formData: {},
      copyFormData: {},
      viewRouteId: null,
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        menu: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        searchMenuSpan: 8,
        selection: true,
        menuWidth: 300,
        column: [
          {
            label: "路线编号",
            prop: "routeCode",
            overHidden: true,
            search: true,
            slot: true,
          },
          {
            label: "路线名称",
            prop: "routeName",
            overHidden: true,
            search: true,
          },
          {
            label: "点位数量",
            prop: "pointCount",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.pointCount || 0;
            },
          },
          {
            label: "预计耗时",
            prop: "estimatedTime",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.estimatedTime ? `${row.estimatedTime}分钟` : "-";
            },
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            overHidden: true,
            search: true,
            searchLabelWidth: 80,
            showColumn: false,
            dataType: "string",
            dicData: [
              { label: "全部状态", value: "" },
              { label: "启用", value: "1" },
              { label: "禁用", value: "0" },
            ],
            slot: true,
          },
          {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            overHidden: true,
            search: false,
          },
          {
            ...searchTimeConfig,
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
            hide: true,
          },
        ],
      },
    };
  },
  methods: {
    /** rich_element 表格行绑定了 tr 的 native click 并转发 row-click；操作列需阻断冒泡，否则会连带触发 avue 打开编辑 */
    absorbMenuCellClick(event) {
      if (event && typeof event.stopPropagation === "function") {
        event.stopPropagation();
      }
    },

    // 新增
    handleAdd() {
      this.viewDialogVisible = false;
      this.copyDialogVisible = false;
      this.isEdit = false;
      this.formData = {};
      this.dialogVisible = true;
    },

    // 查看详情（与编辑弹窗互斥，避免无遮罩的编辑层叠在页面下仍可见）
    handleView(row) {
      this.dialogVisible = false;
      this.copyDialogVisible = false;
      this.viewRouteId = row.id;
      this.viewDialogVisible = true;
    },

    // 编辑
    handleEdit(row) {
      this.viewDialogVisible = false;
      this.isEdit = true;
      this.formData = row;
      this.dialogVisible = true;
    },

    // 切换状态
    handleToggleStatus(row) {
      const newStatus = row.status === 1 ? "禁用" : "启用";
      const statusValue = row.status === 1 ? 0 : 1;
      this.$confirm(`确定要${newStatus}该巡检路线吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
            const resp = await updateStatusBatch({
              ids: row.id,
              status: statusValue,
            });
            if(resp.data.code === 200){
              this.$message.success(resp.data.msg);
              this.onLoad(this.page);
            }

        })
    },

    // 复制
    handleCopy(row) {
      this.$confirm("确定要复制该巡检路线吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          this.copyFormData = { ...row };
          this.copyDialogVisible = true;
        })
    },

    // 批量启用
    handleBatchEnable() {
      if (!this.ids) {
        this.$message.warning("请先选择要启用的记录");
        return;
      }
      this.$confirm("确定要批量启用选中的记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => this.batchUpdateStatus(1, "启用"))
    },

    // 批量禁用
    handleBatchDisable() {
      if (!this.ids) {
        this.$message.warning("请先选择要禁用的记录");
        return;
      }
      this.$confirm("确定要批量禁用选中的记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => this.batchUpdateStatus(0, "禁用"))
    },

    // 批量更新状态
    async batchUpdateStatus(status, actionName) {
      try {
        this.loading = true;
        const response = await updateStatusBatch({
          ids: this.ids,
          status: status,
        });
        if (response && response.data.code === 200 ) {
          this.$message.success(response.data.msg);

          this.onLoad(this.page);
        }
      }finally {
        this.selectionClear();
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inspection-route-manage {
  ::v-deep .avue-crud__search {
    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }
  }

  ::v-deep .avue-crud__table {
    .el-table__header th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
    .el-table__row:hover {
      background-color: #f5f7fa;
    }
  }

  ::v-deep .el-tag {
    border-radius: 4px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
  }

  ::v-deep .el-button--text {
    padding: 0 8px;
    margin-right: 0;
    &:hover {
      color: #409eff;
    }
  }
}
</style>
